import { render, staticRenderFns } from "./ColorFamilyFilter.vue?vue&type=template&id=31d26128&"
import script from "./ColorFamilyFilter.vue?vue&type=script&lang=js&"
export * from "./ColorFamilyFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports